import { RoleFormMessages, TranslationRoleFormMessages } from "@languages/interfaces";

export const messages: TranslationRoleFormMessages = {
  [RoleFormMessages.fieldName]: "Nombre",
  [RoleFormMessages.fieldDescription]: "Descripción",
  [RoleFormMessages.createRole]: "Crear grupo",
  [RoleFormMessages.editRole]: "Editar grupo",
  [RoleFormMessages.deleteRole]: "Eliminar grupo",
  [RoleFormMessages.confirmDeleteTitle]: "Confirmación de eliminación",
  [RoleFormMessages.confirmDeleteMessage]: "¿Está seguro de que desea eliminar este grupo?"
};